export function BoomerIcon({ width, height, className }: React.SVGProps<SVGElement>) {
  return (
    <img
      src="/heyboomer.png"
      alt="Boomer"
      width={width || "56"}
      height={height || "56"}
      className={className}
    />
  );
}
